import { useEffect, useMemo, useState } from 'react';

// `resetKey` is an optional value (e.g. a search term) that, when changed, jumps back to page 1.
export default function usePagination(items, pageSize = 10, resetKey) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
    // Intentionally only reacting to resetKey — this effect's sole purpose is the reset trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageItems = useMemo(
    () => items.slice((currentPage - 1) * pageSize, currentPage * pageSize),
    [items, currentPage, pageSize],
  );

  return { page: currentPage, setPage, totalPages, pageItems };
}
